export class NewPartnerModel {
  first = '';
  last = '';
  email = '';
}
